var _circle, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGmailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 28,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9585 40.9232H20.5261V29.8304L14.001 24.9365V38.9656C14.001 40.0488 14.8786 40.9232 15.9585 40.9232Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1865 40.9242H40.7541C41.8373 40.9242 42.7117 40.0465 42.7117 38.9666V24.9375L36.1865 29.8314",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1865 21.3479V29.8306L42.7117 24.9367V22.3266C42.7117 19.9058 39.9483 18.5257 38.0136 19.9776",
    fill: "#FBBC04"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5254 29.8313V21.3486L28.3556 27.2213L36.1858 21.3486V29.8313L28.3556 35.704",
    fill: "#EA4335"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.001 22.3266V24.9367L20.5261 29.8306V21.3479L18.6991 19.9776C16.7611 18.5257 14.001 19.9058 14.001 22.3266Z",
    fill: "#C5221F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmailIcon);
export default __webpack_public_path__ + "static/media/gmailIcon.5ca9a0b42c61ce891db9cc9d3f733ef5.svg";
export { ForwardRef as ReactComponent };